import apiClient from './apiClient';

export async function getDashboard() {
  const res = await apiClient.get('/dashboard');
  return res.data.data;
}

export async function globalSearch(query) {
  const res = await apiClient.get('/search', { params: { q: query } });
  return res.data.data;
}

export async function getCustomerStatus() {
  const res = await apiClient.get('/dashboard/customers');
  return res.data.data;
}

export async function customerSearch(q) {
  const res = await apiClient.get('/dashboard/customer-search', { params: { q } });
  return res.data.data.items;
}

export async function getCustomersDispatched(month) {
  const res = await apiClient.get('/dashboard/customers-dispatched', { params: month ? { month } : {} });
  return res.data.data;
}

export async function getDashboardInsights() {
  const res = await apiClient.get('/dashboard/insights');
  return res.data.data;
}

export async function getMonthDaily(month) {
  const res = await apiClient.get('/dashboard/month-daily', { params: { month } });
  return res.data.data;
}

export async function getReactivated() {
  const res = await apiClient.get('/dashboard/reactivated');
  return res.data.data;
}

export async function getRefPartyMonthly(refPartyId) {
  const res = await apiClient.get('/dashboard/refparty-monthly', { params: refPartyId ? { refPartyId } : {} });
  return res.data.data;
}

export async function getRefPartyMonth(month, refPartyId) {
  const res = await apiClient.get('/dashboard/refparty-month', { params: refPartyId ? { month, refPartyId } : { month } });
  return res.data.data;
}

export async function getRefPartyLines({ month, party, date, sizeId, customerId, group }) {
  const params = { month };
  if (party) params.refPartyId = party;
  if (date) params.date = date;
  if (sizeId) params.sizeId = sizeId;
  if (customerId) params.customerId = customerId;
  if (group) params.group = group;
  const res = await apiClient.get('/dashboard/refparty-lines', { params });
  return res.data.data;
}

export async function getCustomersMonthly() {
  const res = await apiClient.get('/dashboard/customers-monthly');
  return res.data.data;
}

export async function getReorderDue() {
  const res = await apiClient.get('/dashboard/reorder-due');
  return res.data.data;
}

export async function getWinBack() {
  const res = await apiClient.get('/dashboard/win-back');
  return res.data.data;
}

export async function getTargets(month) {
  const res = await apiClient.get('/dashboard/targets', { params: month ? { month } : {} });
  return res.data.data;
}

export async function setTarget({ refPartyId, month, target }) {
  const res = await apiClient.put('/dashboard/targets', { refPartyId, month, target });
  return res.data.data;
}

export async function getTrend() {
  const res = await apiClient.get('/dashboard/trend');
  return res.data.data;
}

export async function getMonthCompare(month) {
  const res = await apiClient.get('/dashboard/month-compare', { params: month ? { month } : {} });
  return res.data.data;
}

// DESIGN-BUYERS v1
export async function getDesignBuyers({ design, sizeId, months } = {}) {
  const params = {};
  if (design) params.design = design;
  if (sizeId) params.sizeId = sizeId;
  if (months !== undefined && months !== '') params.months = months;
  const res = await apiClient.get('/dashboard/design-buyers', { params });
  return res.data.data;
}
